export default __webpack_public_path__ + "static/media/1861.e2b76be6.png";